import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { DjayAvatar } from '../../mascot';
import { Clock, Calendar, PlayCircle } from 'lucide-react';
interface AssignedAssessmentBannerProps {
  assignment: any;
  teacherName: string;
  onStartAssessment: () => void;
}
export function AssignedAssessmentBanner({
  assignment,
  teacherName,
  onStartAssessment
}: AssignedAssessmentBannerProps) {
  const deadlineStr = assignment.deadline ? new Date(assignment.deadline).toLocaleDateString('nl-NL', {
    day: 'numeric',
    month: 'long'
  }) : null;
  return <Card className="p-3 sm:p-6 border-2 border-blue-200 shadow-sm bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl relative overflow-hidden" data-id="element-1070">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-1071" />

      <div className="relative z-10 flex flex-row items-center gap-3 sm:gap-6" data-id="element-1072">
        <div className="flex-shrink-0" data-id="element-1073">
          <div className="block sm:hidden" data-id="element-1074">
            <DjayAvatar size="sm" emotion="encouraging" animate data-id="element-1075" />
          </div>
          <div className="hidden sm:block" data-id="element-1076">
            <DjayAvatar size="md" emotion="encouraging" animate data-id="element-1077" />
          </div>
        </div>

        <div className="flex-1 text-left" data-id="element-1078">
          <div className="text-[10px] sm:text-sm font-bold text-blue-600 uppercase tracking-wider mb-0.5 sm:mb-1" data-id="element-1079">
            Toets van {teacherName}
          </div>
          <h3 className="text-base sm:text-xl font-black text-slate-900 mb-1 sm:mb-2 leading-tight" data-id="element-1080">
            {assignment.domainLabel}
          </h3>

          <div className="flex flex-wrap items-center justify-start gap-2 sm:gap-4 text-xs sm:text-sm font-medium text-slate-600 mb-2 sm:mb-4" data-id="element-1081">
            <div className="flex items-center gap-1 bg-white/60 px-1.5 py-0.5 sm:px-2.5 sm:py-1 rounded-md border border-blue-100" data-id="element-1082">
              <Clock className="w-3 h-3 sm:w-4 sm:h-4 text-blue-500" data-id="element-1083" />~
              {assignment.estimatedMinutes} min
            </div>
            {deadlineStr && <div className="flex items-center gap-1 bg-white/60 px-1.5 py-0.5 sm:px-2.5 sm:py-1 rounded-md border border-blue-100" data-id="element-1084">
                <Calendar className="w-3 h-3 sm:w-4 sm:h-4 text-blue-500" data-id="element-1085" />
                Voor {deadlineStr}
              </div>}
          </div>

          <Button onClick={onStartAssessment} size="sm" className="w-full sm:w-auto bg-blue-500 hover:bg-blue-600 text-white shadow-sm" data-id="element-1086">
            <PlayCircle className="w-4 h-4 sm:w-5 sm:h-5 mr-1.5 sm:mr-2" data-id="element-1087" />
            Start toets
          </Button>
        </div>
      </div>
    </Card>;
}